import router from '@/router'
import adminLoginApi from '@/api/admin/AdminLogin'
import adminMenuApi from '@/api/admin/AdminMenu'

const state = {
  token: null,
  id: null,
  name: null,
  role: null,
  groupId: null,
  authMenus: [],
  adminMain: null,
  authGubun: null
}

const getters = {
  token: state => state.token,
  id: state => state.id,
  name: state => state.name,
  role: state => state.role,
  groupId: state => state.groupId,
  authMenus: state => state.authMenus,
  adminMain: state => state.adminMain,
  authGubun: state => state.authGubun
}

const mutations = {
  login (state, item) {
    state.token = item.token
    state.id = item.data.userId
    state.name = item.data.userNm
    state.role = item.data.role
    state.groupId = item.data.groupId
    state.authMenus = item.authMenus
    state.adminMain = item.adminMain
  },
  logout (state) {
    state.token = null
    state.id = null
    state.name = null
    state.role = null
    state.groupId = null
    state.authMenus = []
    state.adminMain = null
  },
  setTrueAuthGubun (state) {
    state.authGubun = true
  },
  setFalseAuthGubun (state) {
    state.authGubun = false
  }
}

const actions = {
  async login ({ commit }, { id, password }) {
    const params = {
      userId: id,
      userPwd: password
    }
    const result = await adminLoginApi.login(params)
    if (result.status === 403) {
      const cntResult = await adminLoginApi.selectLoginCount(params)
      const cnt = Number(cntResult[0].loginCount)
      if (cnt < 5) {
        const loginCount = 5 - (cnt + 1)
        alert('아이디와 비밀번호가 일치하지 않습니다. 총 ' + loginCount + '회의 로그인 시도가 가능합니다.')

        const cntParams = {
          userId: id,
          loginCount: cnt + 1
        }
        await adminLoginApi.updateLoginCount(cntParams)
      } else {
        alert('로그인 횟수 제한이 초과된 아이디입니다. 관리자에게 문의하여 주십시오.')
      }
      return false
    } else if (result.status === 404) {
      alert('아이디가 존재하지 않습니다.')
      return false
    } else {
      const cntResult = await adminLoginApi.selectLoginCount(params)
      const cnt = Number(cntResult[0].loginCount)
      if (cnt < 5) {
        const cntParams = {
          userId: id,
          loginCount: 0
        }
        await adminLoginApi.updateLoginCount(cntParams)
        const param = { groupId: result.data.groupId }
        const authMenuData = await adminMenuApi.selectAdminAuthMenuList(param)
        const authMenus = []
        for (const routeMenu of router.options.routes) {
          if (routeMenu.path.substr(0, 6) === '/admin' && routeMenu.meta.visible) {
            for (const leftMenu of authMenuData) {
              if (leftMenu.programPath === null) {
                const childList = []
                for (const leftSubMenu of authMenuData) {
                  for (const routeSub of routeMenu.children) {
                    if (leftSubMenu.upperMenuId === leftMenu.menuId && leftSubMenu.menuId === routeSub.meta.menuId) {
                      childList.push(routeSub)
                    }
                  }
                }
                if (childList.length > 0) {
                  routeMenu.children = childList
                  authMenus.push(routeMenu)
                }
              }
            }
          }
        }
        result.authMenus = authMenus
        result.adminMain = authMenus[0].path + '/' + authMenus[0].children[0].path
        commit('login', result)
        router.push({ name: authMenus[0].children[0].name })

      } else {
        alert('로그인 횟수 제한이 초과된 아이디입니다. 관리자에게 문의하여 주십시오.')
        return false
      }
    }
  },
  async logout ({ commit }, { id }) {
    const param = {
      userId: id
    }
    await adminLoginApi.updateLogoutDate(param)
    commit('logout')
    // router.push({ name: 'AdminLogin' })
    router.push('/loginAdmin')
  }
}




export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
